export const COLUMN_RESULTS_REVIEW = [
  // {
  //   label: 'Order',
  //   stateValue: 'order',
  //   width: 40,
  // },
  {
    label: 'Name',
    stateValue: 'name',
    minWidth: 120,
  },
  {
    label: 'NRIC',
    stateValue: 'idNumber',
  },
  {
    label: 'Date of upload',
    stateValue: 'dateUpload',
    sortBy: 'Date',
  },
  {
    label: 'Date of screening',
    stateValue: 'dateScreening',
    sortBy: 'Date',
  },
  {
    label: 'Doctor assigned',
    stateValue: 'doctorAssigned',
    minWidth: 120,
  },
  {
    label: 'Review status',
    stateValue: 'reviewerStatus',
  },
  // {
  //   label: 'FUT status',
  //   stateValue: 'futStatus',
  // },
  {
    label: 'Last signed by',
    stateValue: 'lastSignedBy',
    minWidth: 120,
  },
  {
    label: 'Signed on',
    stateValue: 'signedOn',
  },
  {
    label: 'Time signed',
    stateValue: 'timeSigned',
  },
  {
    label: 'Action',
    stateValue: 'action',
  },
];

export const HS_RESULTS_REVIEW_DISPLAY_STATUS = {
  Draft: 'Draft',
  Pending: 'Pending',
  Completed: 'Completed',
  ReviewRequired: 'Review Required',
};

export const HS_RESULTS_REVIEW_DISPLAY_FUT_STATUS = {
  Generated: 'Generated',
  Pending: 'Pending',
  Late: 'Late',
  Incomplete: 'Incomplete',
};

export const HS_RESULTS_REVIEW_STATUS_COLORS = {
  [HS_RESULTS_REVIEW_DISPLAY_STATUS.Draft]: {
    txt: '#333333',
    background: '#f1f1f1',
  },
  [HS_RESULTS_REVIEW_DISPLAY_STATUS.Pending]: {
    txt: '#E37F2A',
    background: '#e37f2a29',
  },
  [HS_RESULTS_REVIEW_DISPLAY_STATUS.Completed]: {
    txt: '#0B8E5E',
    background: '#15a47029',
  },
  [HS_RESULTS_REVIEW_DISPLAY_FUT_STATUS.Generated]: {
    txt: '#0B8E5E',
    background: '#15a47029',
  },
  [HS_RESULTS_REVIEW_DISPLAY_FUT_STATUS.Pending]: {
    txt: '#E37F2A',
    background: '#e37f2a29',
  },
  [HS_RESULTS_REVIEW_DISPLAY_FUT_STATUS.Late]: {
    txt: '#AD5E99',
    background: '#FFE9FB',
  },
  [HS_RESULTS_REVIEW_DISPLAY_FUT_STATUS.Incomplete]: {
    txt: '#DB3D49',
    background: '#db3d4929',
  },
  [HS_RESULTS_REVIEW_DISPLAY_STATUS.ReviewRequired]: {
    txt: '#9365E8',
    background: '#9365e829',
  },
};

export const RESULTS_REVIEW_STATUS = [
  {
    value: 'Draft',
    key: 'Draft',
  },
  {
    value: 'Review Required',
    key: 'ReviewRequired',
  },
  {
    value: 'Pending',
    key: 'Pending',
  },
  {
    value: 'Completed',
    key: 'Completed',
  },
];

export const RESULTS_REVIEW_FUT_STATUS = [
  {
    value: 'Generated',
    key: 'Generated',
  },
  {
    value: 'Pending',
    key: 'Pending',
  },
  {
    value: 'Late',
    key: 'Late',
  },
  {
    value: 'Incomplete',
    key: 'Incomplete',
  },
];
